import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { BottomCTA } from './components/BottomCTA';
import { ArrowRightIcon, ShieldCheckIcon, ClockIcon, HomeIcon } from 'lucide-react';
export function App() {
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [riskLevel, setRiskLevel] = useState('');
  const navigate = useNavigate();
  const handleStartQuiz = () => {
    navigate('/quiz');
  };
  const handleCTAClick = () => {
    window.location.href = 'https://go.adt212.net/t/t?a=1960533651&as=1971362379&t=2&tk=1';
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">HemTryggt | Upptäck hur säkert ditt hem egentligen är</title>
        <meta name="description" content="Ta vårt snabba säkerhetsquiz och få en personlig bedömning av ditt hems sårbarhet." data-id="element-3" />
      </Helmet>
      <Header onStartQuiz={handleStartQuiz} data-id="element-4" />
      <main className="flex-grow" data-id="element-5">
        {/* Hero section with clear value proposition */}
        <section className="py-12 px-4 bg-white" data-id="element-6">
          <div className="container mx-auto max-w-4xl text-center" data-id="element-7">
            <div className="inline-block bg-red-50 text-red-800 px-3 py-1 rounded-full text-sm font-medium mb-6" data-id="element-8">
              6 frågor · 60 sekunder · Få din risknivå
            </div>
            <h2 className="text-2xl md:text-4xl font-bold mb-6" data-id="element-9">
              Upptäck hur säkert ditt hem{' '}
              <span className="text-red-600" data-id="element-10">egentligen är</span>
            </h2>
            <p className="text-lg mb-8 max-w-2xl mx-auto" data-id="element-11">
              Ta vårt snabba säkerhetsquiz och få en personlig bedömning av ditt
              hems sårbarhet.
              <span className="font-medium" data-id="element-12">
                {' '}
                94% av svenskar har minst en säkerhetsbrist i hemmet.
              </span>
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-13">
              <button onClick={handleStartQuiz} className="group bg-red-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-red-700 transition-all text-lg flex items-center justify-center shadow-lg hover:shadow-xl" data-id="element-14">
                Starta 60-sekunders quizet
                <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-15" />
              </button>
              <button onClick={handleCTAClick} className="bg-white text-red-600 border-2 border-red-600 px-8 py-4 rounded-lg font-semibold hover:bg-red-50 transition-colors text-lg" data-id="element-16">
                Prata med en rådgivare
              </button>
            </div>
            <p className="text-sm text-gray-600 mb-6" data-id="element-17">
              ✓ Inga förpliktelser. ✓ Tar bara en minut. ✓ 100% kostnadsfritt.
            </p>
            {/* Social proof */}
            <div className="flex justify-center items-center gap-6 flex-wrap text-sm text-gray-600 mt-8" data-id="element-18">
              <div className="flex items-center" data-id="element-19">
                <div className="bg-gray-100 rounded-full p-2 mr-2" data-id="element-20">
                  <ShieldCheckIcon className="h-4 w-4 text-red-600" data-id="element-21" />
                </div>
                <span data-id="element-22">5.1+ miljoner skyddade hem</span>
              </div>
              <div className="flex items-center" data-id="element-23">
                <div className="bg-gray-100 rounded-full p-2 mr-2" data-id="element-24">
                  <ClockIcon className="h-4 w-4 text-red-600" data-id="element-25" />
                </div>
                <span data-id="element-26">35+ års erfarenhet</span>
              </div>
              <div className="flex items-center" data-id="element-27">
                <div className="bg-gray-100 rounded-full p-2 mr-2" data-id="element-28">
                  <HomeIcon className="h-4 w-4 text-red-600" data-id="element-29" />
                </div>
                <span data-id="element-30">#1 i Sverige</span>
              </div>
            </div>
          </div>
        </section>
        {/* Testimonial section */}
        <section className="py-10 px-4 bg-gray-50" data-id="element-31">
          <div className="container mx-auto max-w-4xl" data-id="element-32">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-33">
              <div className="flex items-start gap-4" data-id="element-34">
                <div className="flex-shrink-0" data-id="element-35">
                  <img src="https://randomuser.me/api/portraits/women/42.jpg" alt="Kundrecension" className="w-16 h-16 rounded-full object-cover" data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <div className="flex text-yellow-400 mb-2" data-id="element-38">★★★★★</div>
                  <p className="italic mb-3" data-id="element-39">
                    "Jag hade ingen aning om hur sårbart mitt hem var förrän jag
                    tog quizet. Nu har jag ett professionellt larm och kan
                    äntligen sova lugnt."
                  </p>
                  <p className="font-medium" data-id="element-40">Lena Johansson</p>
                  <p className="text-sm text-gray-600" data-id="element-41">Villaägare, Stockholm</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <BottomCTA onCTAClick={handleCTAClick} riskLevel={riskLevel} quizCompleted={quizCompleted} data-id="element-42" />
      <Footer data-id="element-43" />
    </div>;
}